<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AxlrMs/tc-custom/9780989405010.jpg?1725275974930" alt="This image is the cover for the book Becoming Alpha, Alpha Girls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Becoming Alpha, Alpha Girls
      </h1>
      <p class="bookDescription body article font2">
        <i>One stupid party. One stupid boy. One stupid kiss. And my life was virtually over.</i><br/><br/>Tessa McCaide has a unique talent for getting into trouble. Then again, it isn’t easy for a girl with psychic visions to ignore what she sees. Luckily Tessa and her family are leaving California and moving halfway across the country, giving her the perfect opportunity to leave her reputation as “Freaky Tessa” behind.<br/><br/>But Tessa doesn’t realize that kissing the wrong guy in her new Texas town could land her in far more trouble than she ever imagined. Like being forced to attend St. Ailbe’s Academy, a secret boarding school for werewolves.<br/><br/>Even if the wrong guy did accidentally turn her into a shapeshifter and doom her to attending the weirdest high school ever, Tessa can’t help her growing attraction to the mysterious Dastien Laurent.<br/><br/>When vampires attack St. Ailbe’s and her visions pinpoint an enemy in their midst, Tessa realizes that boy drama and her newfound canine tendencies might just be the least of her problems.<br/><br/><b>“This is absolutely one of the most amazing books of 2013! Paranormal YA at its best. It doesn’t matter if you’re an adult or Young Adult. You will love this one.”</b> — <i>Paranormal Cravings Blog</i><br/><br/><b>“Becoming Alpha is a great addition to the werewolf ranks – Erin’s world-building is excellent and her characters are big and bold, making for a wonderful read."</b> - <i>Escape Into Worlds</i><br/><br/><br/>Binge the complete <b><i>Alpha Girls</i></b> series now!<br/><br/>Book 1: <b>Becoming Alpha</b><br/>Book 2: <b>Avoiding Alpha</b><br/>Book 3: <b>Alpha Divided</b><br/>Book 4: <b>Bruja</b><br/>Book 5: <b>Alpha Unleashed</b><br/>Book 6: <b>Shattered Pack</b><br/>Book 7: <b>Being Alpha</b><br/>Book 8: <b>Lunar Court</b><br/>Book 9: <b>Alpha Erased</b><br/><br/><b>Get ready for <b><i>Off Planet</i></b>, the biggest and boldest adventure yet from the mind of Aileen Erin. It's perfect for fans of Suzanne Collins' <b><i>The Hunger Games</i></b>, Claudia Gray's <b><i>Defy the Stars</i></b>, and Maura Milan's <b><i>Ignite the Stars</i></b>!</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aileen Erin
      </h2>
      
      <p class="authorDescription body article"><i>USA Today</i> Bestselling Author Aileen Erin is half-Irish, half-Mexican, and 100% nerd—from Star Wars (prequels don’t count) to Star Trek (TNG FTW). She geeks out on Tolkien's linguistics, and has a severe fascination with the supernatural. Aileen has a BS in Radio-TV-Film from the University of Texas at Austin, and an MFA in Writing Popular Fiction from Seton Hill University. She lives with her husband and daughter in Los Angeles, and spends her days doing her favorite things: reading books, creating worlds, and kicking ass. <br><br>Aileen is the author of the <b>Aunare Chronicles</b>, a scifi action romance series, and the wildly loved YA paranormal <b>Alpha Girls</b> series. She's excited to annouce her upcoming YA paranormal series the <b>Days of Iron and Clay</b>. This new series follows Samantha Lopez, the resident demonologist from the Alpha Girls books. Samantha's first appearance can be found in <i>Being Alpha</i>, Book Seven of the Alpha Girls series.<br><br>Aileen's fans call her stories <b>"jaw dropping," "electrifying," "amazing,"</b> and <b>"bloody brilliant."</b> Bloggers say <b>"Erin's world-building is excellent and her characters are big and bold"</b>(Escape Into Worlds) and every book is <b>"a magnet that just keeps pulling until you feel as if you are falling down, down, down right into its world"</b> (Tempest of Books). Aileen Erin is the founder and CEO of Ink Monster, building worlds filled with girl power and happily ever afters.  You can find her at www.aileenerin.com or on Instagram @aileenerin.</p>
      
      
         <a class="authorURL body link" href="http://inkmonster.net/authors/aerin" target="_blank">
      
              About Author
         </a>
         <br/>
      
         <a class="authorURL body link" href="https://www.facebook.com/aelatcham" target="_blank">
      
              More  About Author
         </a>
         <br/>
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ink Monster
     </h2>
        
        
     <a class="publisherURL body link" href="http://inkmonster.net/" target="_blank">
  
          About Publisher
     </a>
     <br/>
  
     <a class="publisherURL body link" href="http://inkmonster.net/blog" target="_blank">
  
          More  About Publisher
     </a>
     <br/>
  
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?04901273